import { setIsSavingSettings, useAppDispatch } from '@salescore/client-redux'

import { useVmid } from '../components/VmidContext'
import { useViewStateIsSavingSettings } from './useViewState'

export const useIsSavingSettings = (): [boolean, (isSaving: boolean) => void] => {
  const vmid = useVmid()
  const isSavingSettings = useViewStateIsSavingSettings()
  const dispatch = useAppDispatch()
  const updateFunction = (isSaving: boolean) => {
    dispatch(setIsSavingSettings({ vmid, value: isSaving }))
  }

  return [isSavingSettings, updateFunction]
}
